import { combineAuth } from './hr-authority';
import {PersonnelAuthority} from "./personnel-authority";

export class PersonnelCardAuthority extends PersonnelAuthority{

    public static readonly EDIT = "edit";
    public static readonly READ = "edit:read";

    constructor(authority: string) {
        super(authority);
        this.EDIT = combineAuth(this.BASE, PersonnelCardAuthority.EDIT);
        this.READ = combineAuth(this.BASE, PersonnelCardAuthority.READ);
    }

    public readonly EDIT: string;
    public readonly READ: string;
}
